import { useEffect } from "react";
import LR from "logrocket";
import { useUser } from "src/contexts/user-context";
import { useFlags } from "launchdarkly-react-client-sdk";

export const Logrocket = () => {
  const { user, workspace, featureFlags } = useUser();
  const { appLogrocketDisabled } = useFlags();

  // TODO(eric.lovett): This `biome-ignore` was part of a blanket suppression so that we could
  // turn on the rule. It is probably covering up a real bug. Please fix this or replace this
  // TODO with an explanation of why we don't want all deps listed.
  // biome-ignore lint/correctness/useExhaustiveDependencies: legacy suppression, probably a bug
  useEffect(() => {
    if (
      import.meta.env.PROD &&
      user &&
      !featureFlags?.logrocket_disabled &&
      !appLogrocketDisabled &&
      !workspace?.organization?.requires_sensitive_data_controls
    ) {
      LR.init("hightouch/hightouch-app", {
        network: {
          // Remove all response bodies
          responseSanitizer: () => null,
        },
      });
      LR.identify(String(user?.id), {
        name: user?.name,
        email: user?.email,
      });
    }
  }, [
    !!user,
    featureFlags,
    appLogrocketDisabled,
    workspace?.organization?.requires_sensitive_data_controls,
  ]);

  return null;
};
